<listbox-empty [variant]="variant" [showIcon]="showIcon">
  <ng-container icon>
    <i class="uil uil-desktop-alt-slash"></i>
  </ng-container>

  <ng-container text>
    {{ text | translate }}
  </ng-container>
</listbox-empty>
